import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';

import rightArrow from '../assets/images/right-arrow.svg';
import leftArrow from '../assets/images/left-arrow.svg';
import triangleButton from '../assets/images/triangle.svg';

import ReactGA from 'react-ga';

var DEFAULT_STATE = {
    easy: true,
    currentTime: 0,
    tapTimingsLeft: [],
    tapTimingsRight: [],
    threshold: 150,
    score: 0,
    hits: 0,
    misses: 0,
    domRendered: false,
    metaDataLoaded: false,
    started: false,
    ended: false
};

class Tap extends Component {
    leftTimeout;
    rightTimeout;

    constructor() {
        super();

        this.state = DEFAULT_STATE;

        this.keydown = this.keydown.bind(this);
    }

    changeSpeed() {
        this.setState({
            tapTimingsLeft: this.state.tapTimingsLeft.filter((tap, i) => {
                return i % 2 === 0;
            }),
            tapTimingsRight: this.state.tapTimingsRight.filter((tap, i) => {
                return i % 2 === 1;
            })
        });
    }

    componentWillMount() {
        this.resetTimings();
    }

    resetTimings() {
        this.setState({
            tapTimingsLeft: this.props.tapTimingsLeft.filter((tap, i) => {
                return i % 2 === 0;
            }),
            tapTimingsRight: this.props.tapTimingsLeft.filter((tap, i) => {
                return i % 2 === 1;
            })
        });
    }

    hit(isLeft) {
        this.setState({
            score: this.state.score + 5,
            hits: this.state.hits + 1
        });
        if (isLeft) {
            if (this.leftTimeout) {
                clearTimeout(this.leftTimeout);
            }
            document.querySelector('#hit-area').classList.remove('left-false');
            document.querySelector('#hit-area').classList.add('left-true');
            this.leftTimeout = setTimeout(() => {
                document.querySelector('#hit-area').classList.remove('left-true')
            }, 100)
        } else {
            if (this.rightTimeout) {
                clearTimeout(this.rightTimeout);
            }
            document.querySelector('#hit-area').classList.remove('right-false');
            document.querySelector('#hit-area').classList.add('right-true');
            this.rightTimeout = setTimeout(() => {
                document.querySelector('#hit-area').classList.remove('right-true')
            }, 100)
        }
    }

    miss(isLeft) {
        this.setState({
            // score: this.state.score - 2,
            misses: this.state.misses + 1
        });
        if (isLeft) {
            if (this.leftTimeout) {
                clearTimeout(this.leftTimeout);
            }
            document.querySelector('#hit-area').classList.remove('left-true');
            document.querySelector('#hit-area').classList.add('left-false');
            this.leftTimeout = setTimeout(() => {
                document.querySelector('#hit-area').classList.remove('left-false')
            }, 100);
        } else {
            if (this.rightTimeout) {
                clearTimeout(this.rightTimeout);
            }
            document.querySelector('#hit-area').classList.remove('right-true')
            document.querySelector('#hit-area').classList.add('right-false')
            this.rightTimeout = setTimeout(() => {
                document.querySelector('#hit-area').classList.remove('right-false')
            }, 100);
        }
    }

    registerTap(time, isLeft) {

        var noteTimes = isLeft ? this.state.tapTimingsLeft : this.state.tapTimingsRight;

        while (time > noteTimes[0] + this.state.threshold) {
            this.miss(isLeft);
            noteTimes.shift();
        }

        if (time < noteTimes[0] - this.state.threshold) {
            this.miss(isLeft);
        } else {
            while (time >= noteTimes[0] - this.state.threshold) {
                if (time <= noteTimes[0] + this.state.threshold) {
                    this.hit(isLeft);
                    noteTimes.shift();
                    break;
                }
            }
        }
        if (isLeft) {
            this.setState({
                tapTimingsLeft: noteTimes
            });
        } else {
            this.setState({
                tapTimingsRight: noteTimes
            });
        }

    }

    componentDidMount() {
        document.addEventListener("keydown", this.keydown, false);
        this.setState({
            domRendered: true
        });
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.keydown, false);
    }

    keydown(e) {
        if (e.keyCode === 37) { //left arrow
            this.registerTap(document.getElementById("tapAudio").currentTime * 1000, true);
        } else if (e.keyCode === 39) {//right arrow
            this.registerTap(document.getElementById("tapAudio").currentTime * 1000, false);
        }
    }

    renderScrollingBubbles(isLeft) {
        var tapTimings = isLeft ? this.state.tapTimingsLeft : this.state.tapTimingsRight;


        return <div id="scrollingDiv" className={isLeft ? "left" : "right"}
                    style={
                        {
                            height: document.getElementById("tapAudio").duration * 1000 + "px",
                            width: (this.state.threshold * 2) + "px",
                            animationDuration: document.getElementById("tapAudio").duration * 1000 + "ms",
                        }
                    }
        >
            {
                tapTimings.map((tap) => {
                    return <div style={
                        {
                            height: "100px",
                            width: "100px",
                            backgroundColor: "#fff",
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            bottom: "calc(5vh + 75px + " + (tap - 70) + "px)",
                            border: "solid #333333 20px",
                            zIndex: "20",
                            borderRadius: "50%",
                        }
                    }
                    />
                })
            }
        </div>
    }

    start() {
        this.setState({
            started: true
        });
        if (this.state.easy) {
            this.changeSpeed();
        }

        document.getElementsByClassName("right").item(0).classList.add("playing");
        document.getElementsByClassName("left").item(0).classList.add("playing");
        document.getElementById("tapAudio").play();
    }

    render() {

        return (
            <div className="tap">
                <div className={"tap-overlay end-overlay " + ((this.state.started && !this.state.ended) ? "started" : "")}>
                    <div className="tap-overlay-circle-container">
                        <div className="tap-overlay-circle">
                            <div className="overlay-circle-text">
                                <h1>{this.state.score}</h1>
                                <h2>final score</h2>
                                <button className="button-primary"
                                        onMouseDown={() => {
                                            ReactGA.event({
                                                category: "Tap Hero",
                                                action: "click",
                                                label: "replay",
                                                value: this.props.songId
                                            });
                                            if(this.props.isReplay) {
                                                ReactGA.event({
                                                    category: "Tap Hero repeat",
                                                    action: "click",
                                                    label: "replay",
                                                    value: this.props.songId
                                                });
                                            }

                                            this.setState(DEFAULT_STATE, () => {
                                                this.resetTimings();
                                                this.setState({
                                                    domRendered: true,
                                                    metaDataLoaded: true
                                                });
                                            });
                                        }}
                                >Replay</button>
                                <button className="button-primary"
                                        onMouseDown={() => {
                                            this.props.setFinalScores(this.state.score , Math.floor(this.state.hits/(this.state.hits+this.state.misses)*100));
                                            this.props.history.push("/end");
                                        }}
                                >Next </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="tap-overlay"
                     className={"tap-overlay opening-overlay " + (this.state.started ? "started" : "")}
                >
                    <div className="tap-overlay-circle-container">
                        <div className="tap-overlay-circle">
                            <div className="overlay-circle-text">
                                <h2>Choose difficulty</h2>
                                <span className="tap-level-container">
                                    <button className="button-previous-difficulty"
                                            onMouseDown={() => {
                                                this.setState({easy: !this.state.easy})
                                            }}
                                    >
                                        <img src={triangleButton}/>
                                    </button>
                                    <ul className="tap-level">
                                      <li className={this.state.easy ? "active" : ""}>Easy</li>
                                      <li className={!this.state.easy ? "active" : ""}>Hard</li>
                                    </ul>
                                    <button className="button-next-difficulty"
                                            onMouseDown={() => {
                                                this.setState({
                                                    easy: !this.state.easy
                                                });
                                            }}
                                    >
                                        <img src={triangleButton}/>
                                    </button>
                                </span>
                                <button className="button-primary button-overlay"
                                        onMouseDown={() => {
                                            this.start();
                                            ReactGA.event({
                                                category: "Tap Hero",
                                                action: "select",
                                                label: this.state.easy ? "Easy" : "Hard",
                                                value: this.props.songId
                                            });
                                            if(this.props.isReplay) {
                                                ReactGA.event({
                                                    category: "Tap Hero repeat",
                                                    action: "select",
                                                    label: this.state.easy ? "Easy" : "Hard",
                                                    value: this.props.songId
                                                });
                                            }
                                        }}
                                >Start</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"tap-score-container "+(this.state.ended ? "ended" : "")}>
                    <div className="tap-score-text">
                        <h1>{this.state.score}</h1>
                        <h2>score</h2>
                    </div>
                    {/* <h1>{this.state.hits}</h1>
                    <h2>hits</h2>

                    <h1>{this.state.misses}</h1>
                    <h2>misses</h2> */}
                </div>

                <main className="game-content">
                    <div className="scrolling-container">
                        {
                            this.state.domRendered && this.state.metaDataLoaded ? this.renderScrollingBubbles(true) : null
                        }
                        {
                            this.state.domRendered && this.state.metaDataLoaded ? this.renderScrollingBubbles(false) : null
                        }
                        <div className="black-lines">
                            <div/>
                            <div/>
                        </div>
                    </div>
                    <div className="hit-area" id="hit-area">
                        <div className="left-earned-points" id="left-earned-points">+5</div>
                        <div className="right-earned-points" id="right-earned-points">+5</div>
                        <img className="arrow-key left-arrow" src={leftArrow}/>
                        <button className="tap-button left-tap"
                                onMouseDown={() => {
                                    this.registerTap(document.getElementById("tapAudio").currentTime * 1000, true);
                                }}
                        >
                        </button>
                        <button className="tap-button right-tap"
                                onMouseDown={() => {
                                    this.registerTap(document.getElementById("tapAudio").currentTime * 1000, false);
                                }}
                        />
                        <img className="arrow-key right-arrow" src={rightArrow}/>
                    </div>

                </main>

                <audio id="tapAudio"
                       controls
                       onEnded={() => {
                           this.setState({ended: true});
                           ReactGA.event({
                               category: "Tap Hero",
                               action: "accuracy",
                               label: (this.state.easy ? "Easy" : "Hard")+": "+Math.floor(this.state.hits/(this.state.hits+this.state.misses)*100)+"%",
                               value: this.props.songId
                           });
                           ReactGA.event({
                               category: "Tap Hero",
                               action: "tap",
                               label: "Difficulty: "+(this.state.easy ? "Easy" : "Hard")+" | Taps: "+(this.state.hits+this.state.misses),
                               value: this.props.songId
                           });
                           if(this.props.isReplay) {
                               ReactGA.event({
                                   category: "Tap Hero repeat",
                                   action: "accuracy",
                                   label: (this.state.easy ? "Easy" : "Hard")+": "+Math.floor(this.state.hits/(this.state.hits+this.state.misses)*100)+"%",
                                   value: this.props.songId
                               });
                               ReactGA.event({
                                   category: "Tap Hero repeat",
                                   action: "tap",
                                   label: "Difficulty: "+(this.state.easy ? "Easy" : "Hard")+" | Taps: "+(this.state.hits+this.state.misses),
                                   value: this.props.songId
                               });
                           }
                       }}
                       onLoadedMetadata={() => {
                           this.setState({metaDataLoaded: true})
                       }}
                >
                    <source src={this.props.audio}/>
                </audio>

                <footer className="page-footer">

                    <Link to="/songs">Exit</Link>
                </footer>
            </div>
        );
    }
}

export default withRouter(Tap);



// WEBPACK FOOTER //
// ./src/components/Tap.js